import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  ResponseDataDC_Usages_Client_Models_UsageCapResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetUsageCap = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId: number;
};
/**
 * Gets the usage ceiling.
 *
 * @returns ResponseDataDC_Usages_Client_Models_UsageCapResponseModel Success
 */
export function getUsageCap(
  { businessUnit, label, customerId, accountId }: GetUsageCap,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataDC_Usages_Client_Models_UsageCapResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/accounts/${accountId}/usagecap`,
      errors: { 400: 'Bad Request', 404: 'Not Found' },
    },
    requestConfig,
  );
}
